module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_1-1.4c5199b6.svg";